import React from 'react';

const Section = ({ title, children }) => (
  <div className="space-y-2">
    <h4 className="font-bold text-[var(--text-primary)]">{title}</h4>
    {children}
  </div>
);

export const TermsOfService = () => (
  <div className="space-y-4 text-sm text-[var(--text-secondary)] max-h-[60vh] overflow-y-auto pr-4">
    <p><strong>Effective Date:</strong> January 14, 2026</p>
    <p>Thank you for choosing Digital Leader Project for your web design needs. By accessing and using our services, you agree to the following terms and conditions:</p>

    <Section title="1. Services Provided">
      <ul className="list-disc pl-5 space-y-1">
        <li>We offer website design, development, and maintenance services.</li>
        <li>We also offer additional services such as website updates and form setups.</li>
      </ul>
    </Section>

    <Section title="2. Client Responsibilities">
      <ul className="list-disc pl-5 space-y-1">
        <li>You are responsible for providing content and required assets for your website.</li>
        <li>Any delays caused by client-related issues may impact delivery timelines.</li>
      </ul>
    </Section>

    <Section title="3. Payment Terms">
      <ul className="list-disc pl-5 space-y-1">
        <li>Payment is due upon completion of the website or based on the terms agreed upon in the project contract.</li>
        <li>Late payments may result in delayed services or project suspension.</li>
      </ul>
    </Section>

    <Section title="4. Refund Policy">
      <p>We do not offer refunds on completed work unless agreed upon in special circumstances.</p>
    </Section>

    <Section title="5. Liability">
      <p>Digital Leader Project is not responsible for any loss or damage arising from the use of the websites we create, including errors in the site’s functionality or security breaches.</p>
    </Section>

    <Section title="6. Intellectual Property">
      <p>Upon full payment, the client retains ownership of the website's design and content, unless otherwise agreed.</p>
    </Section>

    <Section title="7. Termination">
      <p>Either party may terminate the agreement with written notice. If terminated by the client, payment for any completed work is still due.</p>
    </Section>

    <Section title="8. Governing Law">
      <p>These Terms are governed by the laws of [Insert your country or region].</p>
    </Section>

    <div className="pt-4 border-t border-[var(--border-medium)]">
      <p><strong>Contact Information:</strong></p>
      <p>If you have any questions about our Terms of Service, please contact us at: digitalleaderproject@gmail.com</p>
    </div>
  </div>
);
